var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialsCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #979592;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8.8H3.9c-.4,0-.8.2-1.1.5-.3.3-.5.7-.5,1.1v14.1l-1.6,4.7,6.3-1.6h2.6c.4,0,.8-.2,1.1-.5s.5-.7.5-1.1v-7.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.3,10.3l-2.9.5.5-2.9,4.5-4.5c0,0,.2-.2.3-.2.1,0,.2,0,.4,0s.2,0,.4,0c.1,0,.2.1.3.2l1,1c0,0,.2.2.2.3,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1-.1.2-.2.3l-4.5,4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,6.4c0,.9.8,1.6,1.7,1.7.6,0,1.3.1,2,.1s1.3,0,2-.1c.9,0,1.6-.8,1.7-1.7,0-.6.1-1.3.1-2s0-1.3-.1-2c0-.9-.8-1.6-1.7-1.7-.6,0-1.3-.1-2-.1s-1.3,0-2,.1c-.9,0-1.6.8-1.7,1.7,0,.6-.1,1.3-.1,2s0,1.3.1,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,18.5c0,.9.8,1.6,1.7,1.7.6,0,1.3.1,2,.1s1.3,0,2-.1c.9,0,1.6-.8,1.7-1.7,0-.6.1-1.3.1-2s0-1.3-.1-2c0-.9-.8-1.6-1.7-1.7-.6,0-1.3-.1-2-.1s-1.3,0-2,.1c-.9,0-1.6.8-1.7,1.7,0,.6-.1,1.3-.1,2s0,1.3.1,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsCategoryIcon);
export default __webpack_public_path__ + "static/media/testimonialsCategoryIcon.8df378df91f054198248c51ac6a35056.svg";
export { ForwardRef as ReactComponent };